import React from 'react';
import { Box, Typography } from '@mui/material';
import styles from './Details.module.css';
import Prompts from '../components/Prompts';

/**
 * The Details page serves as a container for various modules.
 * Each module is a self-contained component that can be added to or removed from this page.
 */
const Details: React.FC = () => {

  return (
    <Box className={styles.container}>
      <Typography variant="h4" className={styles.title}>Project Details</Typography>
      <Box className={styles.modulesContainer}>
        {/* Add modules here. Each module should be self-contained */}
        <Prompts />
      </Box>
    </Box>
  );
};

export default Details;
